// outsource dependencies
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { Button } from '@nextui-org/react';
import { memo, PropsWithChildren } from 'react';


// local dependencies
import * as ROUTE from '@/constants/routes';
import logoReact from '@/assets/images/react.svg';

const trustedLogosList = [
  [
    { name: 'React', logo: logoReact },
    { name: 'React', logo: logoReact },
    { name: 'React', logo: logoReact },
  ],
  [
    { name: 'React', logo: logoReact },
    { name: 'React', logo: logoReact },
    { name: 'React', logo: logoReact },
  ],
];

export const Hero = memo<PropsWithChildren<{ className?: string }>>(function Hero ({ }) {
  return <div className="isolate min-h-screen mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pb-16 pt-20 text-center lg:pt-32">
    <h1 className="mx-auto max-w-4xl font-display text-5xl font-medium tracking-tight text-slate-900 sm:text-7xl">
      Accounting{ ' ' }
      <span className="relative whitespace-nowrap text-[#fe0149]">
        <svg
          aria-hidden="true"
          viewBox="0 0 418 42"
          className="absolute left-0 top-2/3 h-[0.58em] w-full fill-[#fe0149]/30"
          preserveAspectRatio="none"
        >
          <path
            d="M203.371.916c-26.013-2.078-76.686 1.963-124.73 9.946L67.3 12.749C35.421 18.062 18.2 21.766 6.004 25.934 1.244 27.561.828 27.778.874 28.61c.07 1.214.828 1.121 9.595-1.176 9.072-2.377 17.15-3.92 39.246-7.496C123.565 7.986 157.869 4.492 195.942 5.046c7.461.108 19.25 1.696 19.17 2.582-.107 1.183-7.874 4.31-25.75 10.366-21.992 7.45-35.43 12.534-36.701 13.884-2.173 2.308-.202 4.407 4.442 4.734 2.654.187 3.263.157 15.593-.78 35.401-2.686 57.944-3.488 88.365-3.143 46.327.526 75.721 2.23 130.788 7.584 19.787 1.924 20.814 1.98 24.557 1.332l.066-.011c1.201-.203 1.53-1.825.399-2.335-2.911-1.31-4.893-1.604-22.048-3.261-57.509-5.556-87.871-7.36-132.059-7.842-23.239-.254-33.617-.116-50.627.674-11.629.54-42.371 2.494-46.696 2.967-2.359.259 8.133-3.625 26.504-9.81 23.239-7.825 27.934-10.149 28.304-14.005.417-4.348-3.529-6-16.878-7.066Z"/>
        </svg>
        <span className="relative">made simple</span>
      </span>{ ' ' }
      for small businesses.
    </h1>
    <p className="mx-auto mt-6 max-w-2xl text-lg tracking-tight text-slate-700">
      Most bookkeeping software is accurate, but hard to use. We make the
      opposite trade-off, and hope you don’t get audited.
    </p>
    <div className="mt-10 flex justify-center gap-x-6">
      <Button as={Link} to={ROUTE.SIGN_UP.LINK()} className="rounded-full hover:bg-default-600 hover:text-white">Get 6
        months free</Button>
      <Button as={Link} to={'/'} color="primary" variant="ghost" className="rounded-full group">
        <svg
          aria-hidden="true"
          className="h-3 w-3 flex-none fill-blue-600 group-hover:fill-current group-active:fill-current"
        >
          <path
            d="m9.997 6.91-7.583 3.447A1 1 0 0 1 1 9.447V2.553a1 1 0 0 1 1.414-.91L9.997 5.09c.782.355.782 1.465 0 1.82Z"/>
        </svg>
        <span className="ml-3">Watch video</span>
      </Button>
    </div>
    <div className="mt-36 lg:mt-44">
      <p className="font-display text-base text-slate-900">
        Trusted by these six companies so far
      </p>
      <ul
        role="list"
        className="mt-8 flex items-center justify-center gap-x-8 sm:flex-col sm:gap-x-0 sm:gap-y-10 xl:flex-row xl:gap-x-12 xl:gap-y-0"
      >
        { _.map(trustedLogosList, (group, groupIndex) => (
          <li key={groupIndex}>
            <ul
              role="list"
              className="flex flex-col items-center gap-y-8 sm:flex-row sm:gap-x-12 sm:gap-y-0"
            >
              { _.map(group, (company, index) => (
                <li key={`${company.name}_${index}`} className="flex">
                  <img src={company.logo} alt={company.name}/>
                </li>
              )) }
            </ul>
          </li>
        )) }
      </ul>
    </div>
    <div
      className="absolute inset-x-0 top-[-10rem] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[-20rem]"
      aria-hidden="true"
    >
      <div
        className="relative left-1/2 -z-10 aspect-[1155/678] w-[36.125rem] max-w-none -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-40rem)] sm:w-[72.1875rem]"
        style={{
          clipPath:
            'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
        }}
      />
    </div>
  </div>;
});
